import React from 'react';
import styled from '@emotion/styled';

const coverHeight = {
  mobile: 302,
  desktop: 560,
};

const gradientHeight = {
  mobile: 131,
  desktop: 296,
};

const Container = styled.section<{ containCover?: boolean }>(({ theme, containCover }) => ({
  position: 'relative',
  height: coverHeight.mobile,
  [theme.breakpoints.up('md')]: {
    height: coverHeight.desktop,
    marginBottom: !containCover ? '-5rem' : undefined,
  },
  [`${ImageWrapper}`]: {
    backgroundSize: containCover ? 'contain' : 'cover',
  },
}));

const ImageWrapper = styled.div(({ theme }) => ({
  width: '100%',
  height: coverHeight.mobile,
  position: 'relative',
  zIndex: 0,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  [theme.breakpoints.up('md')]: {
    height: coverHeight.desktop,
    position: 'absolute',
    top: 0,
    left: 0,
  },
}));

const GradientX = styled.div(({ theme }) => ({
  backgroundImage: 'linear-gradient(rgba(28,28,28,0), rgba(28,28,28,1))',
  position: 'absolute',
  bottom: 0,
  width: '100%',
  height: gradientHeight.mobile,
  [theme.breakpoints.up('md')]: {
    height: gradientHeight.desktop,
  },
}));

type StaticHeaderCoverProps = {
  image?: string,
  containCover?: boolean,
  children?: React.ReactNode
}

const StaticHeaderCover = ({ image, containCover, children }: StaticHeaderCoverProps) => (
  <Container className="header-cover" containCover={containCover}>
    <ImageWrapper style={{ backgroundImage: `url(${image})` }}>
      <GradientX />
    </ImageWrapper>
    {children}
  </Container>
);

export default StaticHeaderCover;
